import Vue from 'vue';

Vue.component('sync-index', () =>
    import(/* webpackChunkName: 'sync-index' */ './sync-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/franchise-inventory/sync/index.js